import classNames from "classnames";

interface BudgetUtilizationBarProps {
  utilization: number | null;
  compact?: boolean;
  budgetLabel?: string;
}

export function BudgetUtilizationBar({
  utilization,
  compact = false,
  budgetLabel,
}: BudgetUtilizationBarProps) {
  if (utilization === null) return <span className="text-gray-400">—</span>;

  const isOver = utilization >= 100;
  const fillWidth = Math.min(utilization, 100);

  return (
    <div
      className={classNames("flex items-center gap-2", { "w-full": !compact })}
    >
      <div
        className={classNames(
          "relative bg-gray-100 rounded-full overflow-hidden",
          compact ? "w-20 h-2" : "flex-1 h-3",
        )}
      >
        <div
          className={classNames(
            "h-full rounded-full transition-all",
            isOver ? "bg-red-500" : "bg-green-500",
          )}
          style={{ width: `${fillWidth}%` }}
        />
      </div>
      <span
        className={classNames(
          "font-medium whitespace-nowrap",
          compact ? "text-xs" : "text-sm",
          isOver ? "text-red-600" : "text-gray-600",
        )}
      >
        {budgetLabel
          ? `${budgetLabel} (${Math.round(utilization)}%)`
          : `${Math.round(utilization)}%`}
      </span>
    </div>
  );
}
